/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-sort',['require','underscore','jquery','activities/scenario-activity','activities/ordering-node'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var OrderingNode = require('activities/ordering-node');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivitySort = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    _attemptInt: 0,
    _maxAttempts: 2,

    _collectionArr: null,
    _nodesArr: [],
    doneBtn: null,
    submitBtn: null,
    itemsMC: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      if (this.doneBtn)
      {
        this.doneBtn.off('click');
        this.doneBtn.addClass('disabled');
      }

      _.forEach(this._nodesArr, function(__node) {
        __node.onBeforeDestroy();
      });
      this._nodesArr = null;

      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    begin: function()
    {
      ScenarioActivity.prototype.begin.apply(this, arguments);
      this.playAudio('primary', this.content, this.loadCurrentPhase);
    },

    setupSort: function()
    {
      this._attemptInt = 0;

      this.doneBtn = this.currentScene.find('[data-mc=buttonHolder] [data-mc=done]').hide();//.one('click', $.proxy(this.doneClickHandler, this));//.addClass('disabled');
      this.submitBtn = this.currentScene.find('[data-mc=buttonHolder] [data-mc=submit]').on('click', $.proxy(this.submitClickHandler, this));//.addClass('disabled');
      this.itemsMC = this.currentScene.find('[data-mc=items_mc]');

      var $prevNode;
      var $node;
      var $contentCollection;
      var $rowsArr;
      var $layout;
      var $offset;
      //var $nextColPosition = 0;
      var $collectionArrLengthInt = 0;
      this._nodesArr = [];
      this._collectionArr = this.content.ContentCollection;
      $collectionArrLengthInt = this._collectionArr.length;

      for (var $i = 0; $i < $collectionArrLengthInt; $i++)
      {
        $contentCollection = this._collectionArr[$i];
        $layout = ($contentCollection.layout === 'vertical') ? 1 : 0;
        $offset = (!isNaN($contentCollection.offset)) ? $contentCollection.offset : -1;
        $rowsArr = $contentCollection.ContentButton;
        $rowsArr = _.shuffle($rowsArr);
        //trace('$contentCollection = '+$contentCollection);
        //trace($rowsArr);
        $node = new OrderingNode(this.itemsMC);
        $node.layout = $layout;
        $node.offset = $offset;
        //trace("offset: " + $offset);
        $node.id = $i;
        $node.init($rowsArr);
        this._nodesArr.push($node);

        $prevNode = $node;
      }

      /*this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });

      Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onPress: this.onStartDrag,
        onPressParams: [this],
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');
      this.totalDrops = this.dropPanel.find('.activity-drop').length;*/

      this.disableNodes();
      this.playAudio('audio', this.currentPhase, $.proxy(this.enableNodes, this));
    },

    doneClickHandler: function(e)
    {
      //this.finish();
    },

    submitClickHandler: function(e)
    {
      this.evaluatingAnswers();
    },

    evaluatingAnswers: function()
    {
      var __isCorrect = this.checkSolution();
      var __orderingNode = this._nodesArr[0];

      this._attemptInt++;

      if (__isCorrect)
      {
        this.submitBtn.hide();//.asset.visible = false;
        //this.doneBtn.show();// = true;
        this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.finish, this), $.proxy(this.killSomeTime, this));
      }
      else if (this._attemptInt < 2)
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect-1', this.currentPhase);
      }
      else
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect-2', this.currentPhase, $.proxy(this.finish, this), $.proxy(this.killSomeTime, this));
        //this.doneBtn.show();//.asset.visible = true;
        this.submitBtn.hide();//.asset.visible = false;
        __orderingNode.showAnswer();
      }
    },

    checkSolution: function()
    {
      var orderingNode = this._nodesArr[0];
      //console.log('CHECK SOLUTION', this._nodesArr, this._nodesArr[0]);
      return orderingNode.checkComplete();
    },

    disableNodes: function()
    {
      _.forEach(this._nodesArr, function($node) {
        $node.disableNode();
      });
    },

    enableNodes: function(e)
    {
      _.forEach(this._nodesArr, function($node) {
        $node.enableNode();
      });
    },

    ///////////////////////////////////////////////////////

    onEndDrag: function(self)
    {
      var $drag = $(this.target);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drag') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && Draggable.hitTest($drag, $cDrop, '70%') && $cDrop.attr('data-mc') === 'drop' + self.dropMatch.toString()) // correct
      {
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      this.dropMatch++;
      $drag.empty();
      this.currentScene.find('.bandage-asset').attr('data-frame', 'f' + this.dropMatch);

      Draggable.get($drag).disable();
      $drag.addClass('is-correct');
      $dropItem.addClass('is-correct');
      //$drag.draggable.draggable('disable');

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], this.killSomeTime);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    checkDropAccept: function($valid, $drop, $drag)
    {
      //console.log('check drop', $valid, ('item' + this.dropMatch.toString()), $drag.attr('data-mc'));
      if ($drop.attr('data-mc') === 'drop' + this.dropMatch.toString() &&
          $drag.attr('data-mc') === $valid &&
          'item' + this.dropMatch.toString() === $valid)
      {
        //console.log('match');
        return true;
      }

      return false;
    },

    allComplete: function()
    {
      //console.log('check complete', this.totalDrops);
      if (this.dropMatch >= this.totalDrops || this.isInfant)
        return true;

      return false;
    },

    killSomeTime: function()
    {
      //var $timer:Timer = new Timer(3000);
      //$timer.addEventListener(TimerEvent.TIMER, this.onKilledTime);
      //$timer.start();
      setTimeout($.proxy(this.onKilledTime, this), 2000);
    },

    onKilledTime: function($e)
    {
      //$e.target.removeEventListener(TimerEvent.TIMER, this.onKilledTime);

      this.finish();
    },

    evaluatePerformance: function()
    {
      //console.log('eval perf', this.isInfant, this.totalBlows);
      if (!this.isInfant)
      {
        this.finish('critical');
        return false;
      }
      else if (this.totalBlows !== 5)
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      else
      {
        this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      //console.log('perf', this.performance);
    },

    finalComplete: function()
    {
      this.finish();
    },

    finish: function($performance)
    {
      ScenarioActivity.prototype.finish.apply(this, arguments);
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      this.counterPanel.find('[data-mc=text_tf]').html($sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivitySort;

});

